<template>
  <div class="voluntering-card-list mt-3">
    <a v-for="(value, index) in List" :key="index" :href="value.redirectUrl">
      <b-card
        :key="index"
        :img-src="value.img"
        img-alt="Image"
        img-top
        tag="article"
        class="mb-2 shadow-sm"
        :class="{ 'card-no-image': !value.img }"
      >
        <div v-if="!value.img" class="no-image card-img card-img-top">
          <div class="no-img-container">
            <img
              :src="require('@assets/images/new-icons/no_image.svg')"
              height="44"
              width="44"
            />
            <span>No image available</span>
          </div>
        </div>

        <b-card-text v-if="value.type === 'application'">
          <div class="mission-name">
            <h4 class="card-title">
              <a :href="value.redirectUrl">{{ value.mission_name }}</a>
            </h4>
          </div>
          <span class="location-container">
            <i class="location-icon">
              <img
                :src="require('@assets/images/location-black.svg')"
                :alt="null"
                height="21"
                width="16"
              />
            </i>
            {{ value.location }}
          </span>
          <p>
            {{ value.organization }}
          </p>
          <p class="time">
            <span v-if="value.duration.hours != 0" class="hours">{{
              value.duration.hours
            }}</span
            ><span v-if="value.duration.hours">h </span>
            <span v-if="value.duration.minutes != 0" class="minutes">{{
              value.duration.minutes
            }}</span
            ><span v-if="value.duration.minutes">m</span>
          </p>
        </b-card-text>

        <b-card-text  v-if="value.type === 'team'">
          <div class="team-name">
            <h4 class="card-title">
              {{ value.team_name }}
            </h4>
          </div>
          <span class="location-container">
            <i class="location-icon">
              <img
                :src="require('@assets/images/location-black.svg')"
                :alt="null"
                height="21"
                width="16"
              />
            </i>
            {{ value.location }}
          </span>
          <p>
            {{ value.description }}
          </p>
          <p class="time">
            <span v-if="value.duration.hours != 0" class="hours">{{
                value.duration.hours
              }}</span
            ><span v-if="value.duration.hours">h </span>
            <span v-if="value.duration.minutes != 0" class="minutes">{{
                value.duration.minutes
              }}</span
            ><span v-if="value.duration.minutes">m</span>
          </p>
        </b-card-text>
      </b-card>
    </a>
    <div
      v-if="!List.length > 0"
      class="no-record-found d-flex justify-content-center"
    >
      <div class="no-result-icon-container">
        <span class="i-text">i</span>
        <span class="no-record-text">{{
          this.getTrans("label.no_record_found")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfileCardList",
  props: {
    List: {
      type: Array,
    }
  },
};
</script>

<style lang="scss" scoped>
.voluntering-card-list {
  /deep/.card {
    border-radius: 10px;
    position: relative;
    .card-img-top {
      border-radius: 10px 10px 0 0;
    }
    .card-title {
      font-size: 16px;
      line-height: 16px;
    }
    .location-container {
      font-size: 14px;
      display: block;
      margin-bottom: 10px;
    }
    .time {
      margin-bottom: 0;
    }
  }
}
.hours,
.minutes {
  font-size: 23px;
}
.card-img-top {
  height: 246px;
  background: #eeeeee;
  .no-img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;

    img {
      width: 44px;
      height: 44px;
    }
    span {
      display: block;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
  }
}
.no-image {
  position: absolute;
  top: 0;
  left: 0;
}
.card-no-image {
  padding-top: 246px;
}

.no-result-icon-container {
  margin-top: 40px;
  height: 400px;

  text-align: center;

  .no-record-text {
    color: #757575;
    font-weight: 400;
    font-size: 16px;
  }

  .i-text {
    margin: 0 auto;
    border-radius: 40px;
    width: 61px;
    height: 61px;
    text-align: center;
    background: linear-gradient(94.97deg,
        rgba(172, 219, 74, 0.1) 4.99%,
        rgba(155, 204, 54, 0.1) 96.99%);
    display: flex;
    justify-content: center;
    align-items: center;

    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    color: #9bcc36;
    margin-bottom: 12px;
  }
}
.no-result-icon-container {
    margin-top: 120px !important;
    text-align: center;
}
</style>
